export const TYPES = {
  setExpandedRow: 'SET_EXPANDED_ROW',
  setBreedsAnimals: 'SET_BREEDS_ANIMALS',
  setShowInvalidIcon: 'SET_SHOW_INVALID_ICON',
  setFormAnimal: 'SET_FORM_ANIMAL',
}

export const initialState = {
  expandedRow: null,
  breedsAnimals: false,
  showInvalidIcon: false,
  forms: {
    formAnimal1: {
      birthDate: null,
      species: null,
      breed: null,
    },
  },
}

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case TYPES.setExpandedRow: {
      return {
        ...state,
        expandedRow: action.payload,
      }
    }
    case TYPES.setBreedsAnimals: {
      return {
        ...state,
        breedsAnimals: action.payload,
      }
    }
    case TYPES.setShowInvalidIcon: {
      return {
        ...state,
        showInvalidIcon: action.payload,
      }
    }
    case TYPES.setFormAnimal: {
      return {
        ...state,
        forms: {
          ...state.forms,
          ...action.payload,
        },
      }
    }
    default:
      return state
  }
}
